import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VideoItem, VideoState } from '@/modules/teaching/videos/types/types.ts'

const initialState: VideoState = {
  selected: undefined,
  isOpenModal: false,
  isOpenVideoModal: false,
  isDeleteModalOpen: false
}

const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<VideoItem | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setOpenVideoModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenVideoModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const videoActions = videoSlice.actions
export const { reducer: videoReducer } = videoSlice
